import {
  FETCH_SYNDICATE_SUCCESS,
  FETCH_MEMBER_SYNDICATE_SUCCESS,
  CLEAR_SYNDICATE
} from 'constants/syndicate';

const mySyndicates = (state = null, action) => {
  switch (action.type) {
    case FETCH_SYNDICATE_SUCCESS:
    case FETCH_MEMBER_SYNDICATE_SUCCESS:
      return action.response.result;
    case CLEAR_SYNDICATE:
      return null;
    default:
      return state;
  }
};

export default mySyndicates;



// WEBPACK FOOTER //
// ./src/reducers/currentSyndicate.js